export default "__VITE_ASSET__CphAdDYK__"